import { memo } from "react";
import { ProductionOrder } from "../../components/types";
import Badge from '../../components/Badge';
import { formatDateFromUnix, formatNumberV2 } from "../../utilities/Format";
import { ImCancelCircle } from "react-icons/im";

const Label = ({ label, value, textStyles = '' } : { 
  label: string, value?: string | number, textStyles?: string
}) => 
  <div className='flex'>
    <h6 className="font-bold basis-1/3 lg:basis-1/4">{label}</h6>
    <h6 className={`font-light break-words basis-2/3 lg:basis-3/4${textStyles}`}>{value}</h6>
  </div>

const OrderReceiptApprovalproductionOrder = ({ title, productionOrder, pdApprovedBy, qcApprovedBy, whApprovedBy, faApprovedBy, reworkInfo } : {
  title: string,
  productionOrder: ProductionOrder
  pdApprovedBy?: string,
  qcApprovedBy?: string,
  whApprovedBy?: string,
  faApprovedBy?: string,
  reworkInfo?: {
    isRework: boolean,
    reworkNote: string,
    reworkedBy: string,
    reworkedDatetime: number
  }
})  => {

  const isTrialBatch = productionOrder && productionOrder.trialBatch
  return <>
    <div className='flex items-center justify-between gap-2'>
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-3">
          <h3 className={`my-3`}>{title} - {productionOrder.id}</h3>
          {reworkInfo ? <>
            <p className="flex items-center gap-1 px-2 py-1 font-bold text-red-500 bg-red-100 rounded-lg ">
              <ImCancelCircle size={12} />
              Rejected
            </p>
            <div className="flex-col ">
              <p className="text-sm italic text-red-500">โดย : {reworkInfo.reworkedBy} ({formatDateFromUnix(reworkInfo.reworkedDatetime)})</p>
              <p className="text-sm italic text-red-500">สาเหตุ : {reworkInfo.reworkNote}</p>
            </div>
          </> : null}
        </div>
        <div className="flex gap-1 ">
          {isTrialBatch ? <h6><Badge variant='text-white font-bold bg-yellow-500 text-base'>{productionOrder.trialBatch!}</Badge></h6> : null}
          <h6>
            {productionOrder.orderType === 'REPACK' && <Badge variant="order-repack font-bold text-base"><>{`${productionOrder.orderType}${productionOrder.alternativeText ? ` - ${productionOrder.alternativeText}` : ''}`}</></Badge>}
            {productionOrder.orderType === 'CLAIM' && <Badge variant="order-claim font-bold text-base"><>{`${productionOrder.orderType}${productionOrder.alternativeText ? ` - ${productionOrder.alternativeText}` : ''}`}</></Badge>}
          </h6>
        </div>
      </div>
    </div>
    <div className='grid grid-cols-1 gap-2 md:grid-cols-2'>
      <Label label="Mat Code" value={`${productionOrder?.materialCode}${productionOrder?.barcodeFgCase ? ` (${productionOrder?.barcodeFgCase})` : ''}`} />
      <div className='flex'>
        <h6 className="font-bold basis-1/3 lg:basis-1/4">Mat Description</h6>
        <div className="basis-2/3 lg:basis-3/4">
          <h6 className='font-light break-words '>{productionOrder?.materialDescription}</h6>
          <div className='flex flex-wrap gap-1'>
            {productionOrder?.infoFwt && <Badge variant='product-info'>{productionOrder?.infoFwt}</Badge>}
            {productionOrder?.infoEffBulkDate && <Badge variant='product-info'>{`Eff.Bulk : ${productionOrder?.infoEffBulkDate}`}</Badge>}
            {productionOrder?.infoRefPkg && <Badge variant='product-info'>{productionOrder?.infoRefPkg}</Badge>}
            {productionOrder?.infoPallet && <Badge variant='product-info'>{`Pallet: ${productionOrder?.infoPallet}`}</Badge>}
            {productionOrder?.infoPacking && <Badge variant='product-info'>{`Packing: ${productionOrder?.infoPacking}`}</Badge>}
          </div>
        </div>
      </div>
      <Label label="Order Qty" value={`${formatNumberV2(productionOrder?.orderQty!)} ${productionOrder?.materialUnit || ''}`} />
      <Label label="Date" value={productionOrder?.actualDueDate!} />
      <Label label="PD Approve by" textStyles=' text-green-500 italic' value={pdApprovedBy} />
      <Label label="QC Approve by" textStyles=' text-green-500 italic' value={qcApprovedBy} />
      <Label label="WH Approve by" textStyles=' text-green-500 italic' value={whApprovedBy} />
      <Label label="FA Approve by" textStyles=' text-green-500 italic' value={faApprovedBy} />
    </div>
  </>
}

export default memo(OrderReceiptApprovalproductionOrder);